import React, { useState, useEffect, useContext } from "react";
import Footer from "../../components/dashboard/footer";
import Header from "../../components/dashboard/header";
import Sidebar from "../../components/dashboard/sidebar";
import axios from 'axios';
import moment from "moment";
import Loader from "../../components/loader";
import TableLoader from "../../components/tableLoader";
import DataTable from 'react-data-table-component';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';
import { contentContext } from "../../context/contentContext";
import SessionPopup from "../../pages/SessionPopup";

let { lambda, appname } = window.app;

const RegisteredUsers = () => {
    const [data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [searchVal, setSearchVal] = useState('');
    const [showSessionPopupup, setShowSessionPopupup] = useState(false);
    const [keyForRerender, setKeyForRerender] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(15);
    const [currentPageNew, setCurrentPageNew] = useState(1);

    const { GetTimeActivity } = useContext(contentContext);

    useEffect(() => {
        getRegisteredUsers();
    }, []);

    const getRegisteredUsers = (search = '') => {
        if (GetTimeActivity) GetTimeActivity();
        setIsLoading(true);
        const token = localStorage.getItem("token") || '';
        const userid = localStorage.getItem("userId") || '';

        let url = lambda + '/registrations?appname=' + appname;
        // if (token) url += '&token=' + token;
        // if (userid) url += '&userid=' + userid;
        if (search) url += '&search=' + encodeURIComponent(search);

        axios({
            method: 'POST',
            url: url,
            data: {}
        })
            .then(function (response) {
                if (response?.data?.result === "Invalid token or Expired") {
                    setShowSessionPopupup(true);
                } else {
                    const list = response?.data?.result?.data ?? [];
                    setData(list);
                    global.exportExcelData = list;
                    setKeyForRerender(prev => prev + 1);
                }
                setIsLoading(false);
            })
            .catch(() => setIsLoading(false));
    };

    const handleSearch = () => {
        getRegisteredUsers(searchVal);
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') handleSearch();
    };

    const clearSearch = () => {
        setSearchVal('');
        getRegisteredUsers('');
    };

    const handlePerRowsChange = (newPerPage) => {
        setRowsPerPage(newPerPage);
    };

    const handlePageChange = (page) => {
        setCurrentPageNew(page);
    };

    const customSort = (rows, selector, direction) => {
        const sorted = rows.slice().sort((a, b) => {
            const aField = String(selector(a) ?? '').toLowerCase();
            const bField = String(selector(b) ?? '').toLowerCase();
            if (aField > bField) return direction === 'desc' ? -1 : 1;
            if (aField < bField) return direction === 'desc' ? 1 : -1;
            return 0;
        });
        global.exportExcelData = sorted;
        return sorted;
    };

    const handleExport = () => {
        const modifiedArray = (global.exportExcelData || data).map((each) => ({
            "NAME": each?.name ?? "",
            "EMAIL": each?.email ?? "",
            "PHONE NUMBER": each?.phone ?? "",
            "COMPANY": each?.company ?? "",
            "DESIGNATION": each?.designation ?? "",
            "CREATED ON": each?.created ? moment(each.created).format("DD-MMM-YYYY HH:mm") : "",
        }));
        const worksheet = XLSX.utils.json_to_sheet(modifiedArray);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
        const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
        FileSaver.saveAs(blob, `RegisteredUsers.xlsx`);
    };

    const customNoRecords = () => (
        <div className="empty-state-body empty-record">
            <div className="empty-state__message">
                <span className="material-icons">summarize</span>
                <p className="form-check font-size-16">No registered users found</p>
            </div>
        </div>
    );

    const columns = [
        {
            name: 'NAME',
            selector: row => row?.name ?? "",
            sortable: true,
            grow: 1,
            cell: row => <div className="text-capitalize">{row?.name || "-"}</div>,
        },
        {
            name: 'EMAIL',
            selector: row => row?.email ?? "",
            sortable: true,
            grow: 2,
            cell: row => <div>{row?.email || "-"}</div>,
        },
        {
            name: 'PHONE NUMBER',
            selector: row => row?.phone ?? "",
            sortable: true,
            grow: 1,
            cell: row => <div>{row?.phone || "-"}</div>,
        },
        {
            name: 'COMPANY',
            selector: row => row?.company ?? "",
            sortable: true,
            grow: 1,
            cell: row => <div>{row?.company || "-"}</div>,
        },
        {
            name: 'DESIGNATION',
            selector: row => row?.designation ?? "",
            sortable: true,
            grow: 1,
            cell: row => <div>{row?.designation || "-"}</div>,
        },
        {
            name: 'CREATED ON',
            selector: row => row?.created ?? "",
            sortable: true,
            grow: 1,
            cell: row => (
                <div>{row?.created ? moment(row.created).format("DD-MMM-YYYY HH:mm") : "-"}</div>
            ),
        },
    ];

    return (
        <>
            {showSessionPopupup && <SessionPopup />}
            <div id="layout-wrapper">
                <div className="main-content user-management" style={{ marginLeft: 0 }}>
                    <div className="page-content" style={{ paddingTop: '24px' }}>
                        <div className="container-fluid">

                            <div className="row mb-4 breadcrumb">
                                <div className="col-lg-12">
                                    <div className="d-flex align-items-center">
                                        <div className="flex-grow-1">
                                            <h4 className="mb-2 card-title">REGISTERED USERS</h4>
                                            {/* <p className="menu-path">Reports / <b>Registered Users</b></p> */}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="row table-data">
                                <div className="col-12">
                                    <div className="card">
                                        <div className="card-body">
                                            <div className="row mb-2">
                                                <div className="col-sm-4 button-block">
                                                    <div className="dataTables_length" id="datatable_length">
                                                        <button
                                                            className={`fill_btn ${data.length <= 0 ? 'disable pe-none' : ''}`}
                                                            onClick={handleExport}
                                                        >
                                                            <span className="material-icons">north_east</span>Export
                                                        </button>
                                                    </div>
                                                </div>
                                                <div className="col-sm-8">
                                                    <div className="search-box mb-2 d-inline-block">
                                                        <div className="position-relative">
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                value={searchVal}
                                                                onChange={(e) => setSearchVal(e.target.value)}
                                                                placeholder="Search by Name, Email"
                                                                onKeyPress={handleKeyPress}
                                                            />
                                                            <button className="fill_btn" onClick={handleSearch}>
                                                                <span className="material-icons search-icon">search</span>
                                                            </button>
                                                        </div>
                                                        <div className="dataTables_length" id="datatable_length">
                                                            <button className="fill_btn" onClick={clearSearch}>
                                                                <span className="material-icons-outlined">sync</span>Reset
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <DataTable
                                                key={keyForRerender}
                                                columns={columns}
                                                keyField="_id"
                                                data={data}
                                                direction="auto"
                                                highlightOnHover
                                                pagination
                                                responsive
                                                persistTableHead
                                                striped
                                                subHeaderAlign="right"
                                                noDataComponent={customNoRecords()}
                                                paginationTotalRows={data.length}
                                                onChangeRowsPerPage={handlePerRowsChange}
                                                onChangePage={handlePageChange}
                                                paginationPerPage={rowsPerPage}
                                                paginationDefaultPage={currentPageNew}
                                                paginationRowsPerPageOptions={[15, 25, 50, 75, 100]}
                                                sortFunction={customSort}
                                                paginationComponentOptions={{
                                                    rowsPerPageText: 'Per page:',
                                                    rangeSeparatorText: 'of',
                                                    noRowsPerPage: false,
                                                    selectAllRowsItem: false,
                                                    selectAllRowsItemText: 'All',
                                                }}
                                                progressPending={isLoading}
                                                progressComponent={<TableLoader />}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default RegisteredUsers;
